import { colours } from '@headbox-ui/themes'

const { brick } = colours

export const topNav = {
  border: 0,
  height: '100%'
}

export const subNav = {
  border: 0,
  fontSize: '14px',
  height: 40,
  lineHeight: '40px',
  marginLeft: '-20px'
}

export const drawer = { padding: '48px 0' }
export const button = { backgroundColor: brick[600], borderColor: brick[600] }

// export const s = {
//   button: { backgroundColor: brick[600], borderColor: brick[600] },
//   drawer: { padding: '48px 0' }
// }

// export const sd = {
//   noStyle: { padding: 0, margin: 0, border: 'none', background: 'transparent' },
//   body: { padding: '16px 24px' },
//   avatar: {
//     backgroundColor: brick[600],
//     color: brick[100],
//     cursor: 'pointer',
//     letterSpacing: 1,
//     marginRight: 10
//   },
//   avatarIcon: {
//     backgroundColor: brick[600],
//     color: brick[100],
//     cursor: 'pointer',
//     letterSpacing: 1,
//     marginLeft: 20
//   },

//   menu: { height: '100%', border: 0 }
// }
